import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedReveal, FadeUp } from "@/components/motion/Reveal";
import { Marquee } from "@/components/motion/Marquee";
import { TEAM } from "@/data/site";

function TeamCard({ member, index }) {
  return (
    <FadeUp delay={(index % 5) * 0.08}>
      <div className="group text-center" data-testid={`team-card-${index}`}>
        <div className="relative aspect-[4/5] bg-navy overflow-hidden hairline border flex items-center justify-center">
          {/* subtle gold corner ticks */}
          <span className="absolute top-3 left-3 h-4 w-4 border-t border-l border-gold/40" />
          <span className="absolute top-3 right-3 h-4 w-4 border-t border-r border-gold/40" />
          <span className="absolute bottom-3 left-3 h-4 w-4 border-b border-l border-gold/40" />
          <span className="absolute bottom-3 right-3 h-4 w-4 border-b border-r border-gold/40" />

          <div className="flex flex-col items-center">
            <span className="h-24 w-24 md:h-28 md:w-28 rounded-full border border-gold/60 grid place-items-center transition-transform duration-500 group-hover:scale-105">
              <span className="serif text-2xl md:text-3xl text-gold tracking-wide">{member.initials}</span>
            </span>
            <span className="mono text-[10px] uppercase tracking-[0.3em] text-ivory/70 mt-6">{/Intern/i.test(member.role) ? "Intern" : "Advocate"}</span>
          </div>
        </div>
        <h3 className="serif text-xl md:text-2xl mt-5">{member.name}</h3>
        <div className="mono text-[10px] uppercase tracking-[0.26em] text-[hsl(var(--muted-foreground))] mt-2">{member.role}</div>
      </div>
    </FadeUp>
  );
}

export default function Attorneys() {
  return (
    <div data-testid="attorneys-page">
      <section className="pt-40 pb-14">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10 text-center">
          <div className="mono text-xs uppercase tracking-[0.32em] text-gold mb-6">Meet the Team</div>
          <MaskedReveal
            as="h1"
            className="serif text-6xl md:text-[7vw] leading-[0.94]"
            lines={["Our Attorneys", <>& <em className="italic text-gold">Associates.</em></>]}
          />
          <FadeUp delay={0.35} className="max-w-2xl mx-auto mt-10 text-[hsl(var(--muted-foreground))] leading-relaxed">
            A team of dedicated, experienced and result-driven legal professionals — committed to ethical practice and strong representation.
          </FadeUp>
        </div>
      </section>

      <section className="pb-24">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
            {TEAM.map((m, i) => <TeamCard key={m.name} member={m} index={i} />)}
          </div>

          <FadeUp delay={0.3} className="mt-16 text-center">
            <p className="text-[hsl(var(--muted-foreground))] mb-6">Looking to consult one of our advocates?</p>
            <Link to="/contact" className="btn-ink" data-testid="attorneys-contact">
              Book a Consultation <ArrowUpRight className="h-4 w-4" />
            </Link>
          </FadeUp>
        </div>
      </section>

      <Marquee items={["Committed to Justice", "Dedicated to Excellence", "Trusted Legal Counsel", "Established in Mumbai"]} />
    </div>
  );
}
